import React from 'react';

import TitleBar from 'shared/migration-components/title-bar';

import {Container} from './styles';
import Tabs, {TabProps} from 'shared/migration-components/tabs';
import {
  AdditionalGroupConfigs,
  EditProduct,
  Sizes,
  Sales,
  WorkingPeriods,
} from './components';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';

interface Props {
  activeTab?: string;
}

const ProductDetails: React.FC<Props> = ({activeTab}) => {
  const {isAllowed} = useAccessControls();

  const tabs: TabProps[] = [
    {
      label: 'Editar produto',
      content: <EditProduct />,
      hidden: !isAllowed('products.findOne'),
    },
    {
      label: 'Horários de funcionamento',
      tab: 'working-periods',
      content: <WorkingPeriods />,
      hidden: !isAllowed('products.findOne'),
      createUrl: 'create',
    },
    {
      label: 'Tamanhos',
      tab: 'sizes',
      content: <Sizes />,
      hidden: !isAllowed('products.findOne'),
      createUrl: 'create',
    },
    {
      label: 'Grupo de Adicionais',
      tab: 'additional-group-configs',
      content: <AdditionalGroupConfigs />,
      hidden: !isAllowed('products.findOne'),
      createUrl: 'create',
    },
  ];

  return (
    <Container>
      <TitleBar title="Detalhes do Produto" backUrl="/menu/products" />
      <Tabs {...{activeTab, tabs}} />
    </Container>
  );
};

export default ProductDetails;
